import React, { useEffect, useMemo, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

import { CalendarContainer } from "../styled/scheduler";

import { FiHome, FiSearch } from "react-icons/fi";

import { tallyEvents } from "../function/common";

import DateCell from "./calendar/dateCell";
import Actions from "./calendar/actions";
import CustomEvent from "./calendar/customEvent";
import HamburgerMenu from "./hamburgerMenu";
import SearchEvent from "./searchEvent";

export default function Calendar({
  data,
  handleDateClick,
  calendarRef,
  handleEventClick,
  onDate,
  handleEventDrag,
  setIsBurgerOpen,
  isBurgerOpen,
  clickEvent,
  isSearch,
  setIsSearch,
  searchTxt,
  setSearchTxt,
  holidays,
  events,
  isHolidayOpen,
  addContextMenuListener,
  setOpenComponents,
  weather,
}) {
  const { mySchedSet, isDarkMode } = useSelector((state) => state?.scheduler);

  const isByType = mySchedSet.viewMode === "C";

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });

  const [viewEvents, setViewEvents] = useState([]);

  const fcKey = useMemo(() => {
    try {
      const sigs = (viewEvents || []).map(
        (e) => `${e?.id ?? e?.scheduleNo ?? e?.title ?? ""}|${e?.start ?? ""}|${e?.end ?? ""}`,
      );
      return sigs.join(",");
    } catch (e) {
      return String((viewEvents || []).length);
    }
  }, [viewEvents]);

  useEffect(() => {
    let schedules = [];

    if (isByType) {
      schedules = tallyEvents(events);
    } else {
      schedules = isMobile ? [...events, ...holidays] : events;
    }

    setViewEvents(schedules);
  }, [isMobile, events, holidays, mySchedSet]);

  const clickDate = (info) => {
    handleDateClick(info.date);
    setOpenComponents((data) => ({ ...data, scheduleList: true }));
  };

  const handleSearchClick = () => {
    if (isSearch) {
      setSearchTxt("");
    }
    setIsSearch(!isSearch);
  };

  return (
    <CalendarContainer className={isDarkMode}>
      <div className="mainCalendar" style={{ padding: isSearch ? "4em 0 0" : 0 }}>
        <div className={`searchBtn ${isSearch && isMobile ? "active" : ""}`}>
          <button onClick={handleSearchClick}>{isSearch ? <FiHome /> : <FiSearch />}</button>
        </div>
        {!isSearch && (
          <Actions clickDate={clickDate} handleDateClick={handleDateClick} onDate={onDate} />
        )}
        {isSearch ? (
          <SearchEvent
            data={data}
            clickEvent={clickEvent}
            searchTxt={searchTxt}
            setSearchTxt={setSearchTxt}
            handleDateClick={handleDateClick}
            onDate={onDate}
          />
        ) : (
          <div className={`calendarView-${mySchedSet.viewMode}`}>
            <FullCalendar
              key={fcKey}
              ref={calendarRef}
              initialDate={onDate}
              initialView="dayGridMonth"
              plugins={[dayGridPlugin, interactionPlugin]}
              locale={"ko"}
              contentHeight={"auto"}
              droppable={true}
              events={viewEvents}
              eventDurationEditable={false}
              eventStartEditable={true}
              eventOrder={["start", "-duration", "title", "id"]}
              eventOrderStrict={true}
              eventClick={(info) => handleEventClick(info.el)}
              dateClick={(info) => clickDate(info)}
              eventDrop={handleEventDrag}
              dayMaxEvents={3}
              moreLinkContent={(info) => `+${info.num}`}
              dragScroll={true}
              eventClassNames={(info) =>
                `schedule-${info.event.id}${
                  info.event.extendedProps.completeYn === "Y" ? " complete" : ""
                }`
              }
              datesSet={addContextMenuListener}
              dayCellContent={(info) => (
                <DateCell
                  info={info}
                  holidays={holidays}
                  isHolidayOpen={isHolidayOpen}
                  weather={weather}
                  handleEventClick={handleEventClick}
                />
              )}
              eventContent={(eventInfo) => <CustomEvent eventInfo={eventInfo} />}
              eventOverlap={false}
              slotEventOverlap={false}
            />
          </div>
        )}
      </div>
      {isTablet && !isSearch && (
        <HamburgerMenu
          onDate={moment().format("YYYY-MM-DD hh:mm:00")}
          isBurgerOpen={isBurgerOpen}
          setIsBurgerOpen={setIsBurgerOpen}
        />
      )}
    </CalendarContainer>
  );
}
